<style scoped>
.small-table {
  font-size: 14px;
  line-height: 1.2;
  padding: 2px;
}

.small-table th, .small-table td {
  padding: 4px;
}
.small-table-card {
  padding-top: 8px;
  padding-bottom: 8px;
}
</style>
<template>
  <div>
  <div class="card mb-3">
    <div class="card-body small-table-card">
      <h4 class="">kürzliche manuelle Bestellungen</h4>
      <table class="table table-sm table-hover mb-0 small-table">
        <tr>
          <th>Lieferant</th>
          <th>ArticleId</th>
          <th>Zustand</th>
          <th>Bestellreferenz</th>
          <th>Bestellmenge</th>
          <th>User</th>
          <th>Kaufdatum</th>
        </tr>
        <tr v-for="mh in material.materialHistory">
          <td><strong>{{mh.stock.vendor.name}}</strong></td>
          <td>{{mh.stock.articleId}}</td>
          <td>
            <span v-if="mh.stock.articleCondition == 1">Neu</span>
            <span v-else-if="mh.stock.articleCondition == 2">Gebraucht</span>
            <span v-else>—</span>
          </td>
          <td>{{mh.manualOrderReference}}</td>
          <td>{{mh.manualOrderQuantity}}</td>
          <td>{{getUserShortname(mh.userId)}}</td>
          <td>{{formatDate(mh.created_at)}}</td>
        </tr>
      </table>
    </div>

  </div>
   <div v-if="material !== null"><!-- ====== Html stuff ====== -->
      <material-vendor-stock-table
         :authorization="authorization"
         :material="material"
         :isMaster="isMaster"
         :userName="userName"
         @updateStock="updateStock"
      ></material-vendor-stock-table>

      <div class="card mb-3"> 
         <div class="card-body">
            <h3>Marktplätze</h3>
            <blocker-computed-table :passed-material="passedMaterial" />
         </div>
      </div>

      <div class="list-group-item mt-3"><h3 class="my-2">Live Listings</h3></div>
      <ul class="list-group pb-4">
         <li class="list-group-item"
            v-for='stock in filterMarketAccountStocks()'
            v-bind:key='stock.id'
         >
            <div class="row">

               <!--Stockinfo-->
               <div class="col-2">
                  <div class="row-fluid">
                     <div class="span2">
                        <strong>{{ stock.vendor.name }}</strong><span v-if="stock.vendor.id == 21"> (LZ: {{ stock.vendorDeliveryTime }})</span><br>
                        <span v-if='stock.articleCondition == 1'>Neu</span>
                        <span v-else-if='stock.articleCondition == 2'>Gebraucht</span>
                        <span v-else>condition undefined</span>
                     </div>
                     <div class="span2">{{ Number(stock.purchasePrice).toFixed(2) }} €</div>
                     <div class="span2">Bestand: {{ stock.quantity }}</div>
                     <div class="span2">LK {{stock.vendor.deliveryClass}}</div>
                  </div>
               </div>


               <!---    LiveListing Table    -->
               <div class="col-10">
                  <table class="table table-sm table-hover">
                     <thead>
                        <tr>
                            <th scope="col">Land  </th>
                            <th scope="col" style="width:235px">Market Account</th>
                            <th scope="col">FU    </th>
                            <th scope="col">LSt   </th>
                            <th scope="col">Seller</th>
                            <th scope="col" title="Buy Box Price">BBPrice</th>
                            <th scope="col">FBA   </th>
                            <th scope="col">min   </th>
                            <th scope="col">VK    </th>
                            <th scope="col">max   </th>
                            <th scope="col">PS    </th>
                        </tr>
                     </thead>

                     <tbody>
                        <ngps-row
                           v-for='(mas, i) in filterForNGPSData(stock.marketaccountstocks)'
                           :key="i +'mm'"
                           :live-listing="mas" :material-mm-data="material?.marketMirrorData?.[mas.marketAccountId]"
                        />
                        <sync-live-listing-row
                           v-for='(mas, i) in filterForSyncLiveListings(stock.marketaccountstocks)'
                           :key="i"
                           :live-listing="mas"
                        />
                     </tbody>
                  </table>
               </div>
            </div>
         </li>

      </ul>
      <modal-error-component v-model="modalError"></modal-error-component>
   </div>
  </div>
</template>
<script>
import SyncLiveListingRow from "./materialStockLiveListing/SyncLiveListingRow.vue"
import NgpsRow from "./materialStockLiveListing/NGPSRow.vue"

   export default {
      components: {
         SyncLiveListingRow,
         NgpsRow,
         },
      props: ['passedMaterial', 'authorization', 'isMaster', 'userName', "users"],
      data() {
         return {
            regexLagerPattern: new RegExp("^Lager[0-9]{1,}$|^Ausschussware$"),
            stockSaveProcessing: 0,
            material: this.passedMaterial,
            master: this.isMaster,
            highPriceMarkets: [],
            highPriceVirtualStocks: [],
            highPriceMarketTableConfig: {
               fields: [
                  { key: 'name', label: 'Name' }
               ]
            },
            modalError: {
               show: false,
               title: 'Speichern',
               error: '',
               message: 'Der Speichervorgang konnte aufgrund eines Fehlers nicht durchgeführt werden.'
            },
            tHeight: (window.innerHeight - 200),
         }
      },
      methods: {
         /**
          * groups array of objects by a specific key-value pair.
          * @param xs: array<T>
          * @param k: string,  such that: k <- Object.keys(T)
          * @return { ...key: array<T> }
          */
         groupBy: function(xs, key) {
            return xs.reduce(function(rv, x) { (rv[x[key]] = rv[x[key]] || []).push(x); return rv; }, {});
         },
         reloadBlockerComputed() {
            this.$refs.blockerComputedTable.load();
         },
         updateStock(stocks){
            // console.log(stocks);
            stocks.forEach(_stock => {
               this.material.stocks.forEach(stock =>{
                  if(stock.id === _stock.id){
                     stock = _stock;
                  }
               })
            });
         },
         filterMarketAccountStocks(){
            return this.material.stocks.filter(stock => stock.marketaccountstocks.length > 0)
         },
         filterForSyncLiveListings(listings){
            const filteredStocks = listings.filter(listing => !listing.marketMirrorData)
            return filteredStocks.sort((a,b) => {
               return (b?.priceInfoHistories?.[0]?.priceState ) - (a?.priceInfoHistories?.[0]?.priceState)
            })
         },
         filterForNGPSData(listings){
            return listings.filter(listing => listing.marketMirrorData)
         },
         // filterForLiveListingsNew(listings){
         //    return listings.filter(listing => listing.priceInfoHistories.length == 0 &&
         //       !listing.marketMirrorData)
         // },
        getUserShortname(id) {
          const user = this.users.find(user => user.id === id)
          return user ? user.shortname : '—';
        },
        formatDate(date) {
          return new Date(date).toLocaleDateString('de-DE');
        }
      },

      created()
      {
         // prepare they currency symbol for Stocks, this is in  the wrong place. Already calculated somewhere.
         // Dollwar sign is missing however

         for(let stock of this.material.stocks)
         {
            for(let masx of stock.marketaccountstocks)
            {
               masx.currencyIso = masx.marketaccount.country.currencyIso;
               if(masx.currencyIso == undefined)
               {
                  masx.currencyIso = "EUR";
               }
               // +++ Currency Symbol data prep
               if (masx.currencyIso == "EUR") {
                  masx.currencySymbol = '€';
               } else if (masx.currencyIso == "USD") {
                  masx.currencySymbol = '$';
               } else if (masx.currencyIso == "BPB" || masx.currencyIso == "GBP") {
                  masx.currencySymbol = "£";
               } else {
                  masx.currencySymbol = masx.currencyIso;
               }

               // +++ split priceCalcLog into array:
               masx.priceCalcLog = masx.priceCalcLog.split('\n');
               // load log into json object:
               var pcl = {};
               var k = 0;
               for(let p of masx.priceCalcLog)
               {
                  pcl[k++] = p.split(':');
               }
               masx.priceCalcLog = pcl;

            }
            stock.marketaccountstocks.sort( (v, w) => { return v.marketaccount.country.countryIso.localeCompare(w.marketaccount.country.countryIso) });
         }
         // get marketaccounts:

         Promise.all([
           axios.get('/marketaccount/all')
         , axios.get('/country/all')
         ]).then( response => {
            const marketAccounts = response[0].data;
            const countries      = response[1].data;
            // +++ generate fake livestock if last history entry is in `priceState == -3`
            // for each market. Choose pih with historyId = 0 (newest).
            /*
            for( const priceInfoHistory of this.material.priceInfoHistories) //history entry has marketAccountId, we need to select all stocks for each vendor
            {
               if((priceInfoHistory.historyId == 0) && (priceInfoHistory.priceState == -3))
               {
                  //check if market is not in highPriceMarket array:
                  if( !this.highPriceMarkets.find( entry => {
                     return (entry.id != priceInfoHistory.market.id)
                         && (entry.articleCondition != priceInfoHistory.articleCondition);
                  })) {
                     let market = marketAccounts.find( marketAccount => marketAccount.id == priceInfoHistory.marketAccountId ).market;
                     this.highPriceMarkets.push({
                        name: market.name,
                        articleCondition: priceInfoHistory.articleCondition,
                        countryIso: countries.find( country => country.id == market.countryId ).countryIso
                     });
                  }
               }
            }
            */
            // group pi-histories by market
            // @returns marketAccountId:string => array(:priceInfo-Histories)
             // generate fake livestock (=: highPriceMarkets) if last history entry is in `priceState == -3`
            const historyByMarket = this.groupBy(this.material.priceInfoHistories, 'marketAccountId');
            for(const marketId of Object.keys(historyByMarket))
            {
               const histories = historyByMarket[marketId];
               const latest = histories.find( x => 0 === x.historyId);
               if(!latest) continue;
               if(-3 === latest.priceState) {
                  let market = marketAccounts.find( marketAccount => marketAccount.id == latest.marketAccountId ).market;
                  this.highPriceMarkets.push({
                     name: market.name,
                     articleCondition: latest.articleCondition,
                     countryIso: countries.find( country => country.id == market.countryId ).countryIso,
                     priceInfoHistories: {
                        new:  histories.filter( h => 2 == h.articleCondition ).sort( (v,w) => v.historyId-w.historyId),
                        used: histories.filter( h => 1 == h.articleCondition ).sort( (v,w) => v.historyId-w.historyId)
                     }
                  });
               }
            }
         }).catch( error => {
            alert("etwas ist schief gegangen.");
            console.error(error)
         });
      }
   }
</script>
